var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumb_wrapper"},[_c('h2',{staticClass:"page_title"},[_vm._t("page_title")],2),_c('h4',{staticClass:"breadcrumb_routs"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v(" "+_vm._s(_vm.$t("TITLES.home"))+" ")]),_c('span',[_vm._v(" > ")]),_c('p',[_vm._t("breadcrumb_current_page")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }